const VARIANT_SVG_IDS = {
  holoFilter: 'pkVariantHoloFilter',
  holoUnderlayGrid: 'pkVariantHoloUnderlayGrid',
  holoUnderlayGradient: 'pkVariantHoloUnderlayGradient',
  holoGradient: 'pkVariantHoloGradient',
  boosterFilter: 'pkVariantBoosterFilter',
  boosterGradient: 'pkVariantBoosterGradient',
  antiqueFilter: 'pkVariantAntiqueFilter',
  foilFilter: 'pkVariantFoilFilter',
  foilGradient: 'pkVariantFoilGradient',
  ghostFilter: 'pkVariantGhostFilter',
  ghostGradient: 'pkVariantGhostGradient',
  blueprintFilter: 'pkVariantblueprintFilter',
  blueprintFilterPaper: 'pkVariantblueprintFilterPaper',
  blueprintGrid: 'pkVariantBlueprintGrid',
  deadPixels: 'pkVariantDeadPixels',
  crayonFilter: 'pkVariantCrayonFilter',
  crayonFilterFingerpaint: 'pkVariantCrayonFilterFingerpaint',
  cosmicFilter: 'pkVariantCosmicFilter',
  cosmicGradient: 'pkVariantCosmicGradient',
  cutesyFilter: 'pkVariantCutesyFilter',
  cutesyPattern: 'pkCutesyPattern',
  cutesyPetal: 'pkCutesyPetal',
  cutesyBlossom: 'pkCutesyBlossom',
  cutesyClipPath: 'pkCutesyClipPath',
  matchaFilter: 'pkVariantMatchaFilter', // inverted version of cutesy
  rurikaraFilter: 'pkVariantRurikaraFilter', // alt inverted version of cutesy
  halloweenFilter: 'pkVariantHalloweenFilter',
  halloweenGradient: 'pkVariantHalloweenGradient',
};

export function SharedCardVariantDefs() {
  return (
    <svg className='card-variant-defs' width='0' height='0' aria-hidden='true' focusable='false'>
      <defs>
        <filter id={VARIANT_SVG_IDS.boosterFilter}>
          <feColorMatrix
            type='matrix'
            values='1.06 0 0 0 0  0 1.08 0 0 0  0 0 1.08 0 0  0 0 0 1 0'
          />
        </filter>
        <filter id={VARIANT_SVG_IDS.holoFilter}>
          <feColorMatrix
            type='matrix'
            values='1.06 0 0 0 0  0 1.08 0 0 0  0 0 1.08 0 0  0 0 0 1 0'
          />
        </filter>
        <linearGradient id={VARIANT_SVG_IDS.boosterGradient} x1='0%' y1='0%' x2='100%' y2='0%'>
          <stop offset='0%' stopColor='rgba(255,255,255,0)' />
          <stop offset='20%' stopColor='rgba(215, 131, 173, 0.28)' />
          <stop offset='50%' stopColor='rgba(0,184,255,0.24)' />
          <stop offset='60%' stopColor='rgba(160, 224, 237, 0.22)' />
          <stop offset='90%' stopColor='rgba(160, 224, 237, 0)' />
          <stop offset='100%' stopColor='rgba(255,255,255,0)' />
        </linearGradient>

        <filter id={VARIANT_SVG_IDS.halloweenFilter}>
          <feColorMatrix
            type='matrix'
            values='1.08 0.04 0 0 0.04  0 0.92 0 0 0  0 0 0.85 0 0  0 0 0 1 0'
          />
          <feDisplacementMap in="SourceGraphic" in2="edgeNoise" scale="2" xChannelSelector="R" yChannelSelector="G" />
        </filter>
        <linearGradient id={VARIANT_SVG_IDS.halloweenGradient} x1='0%' y1='0%' x2='0%' y2='100%'>
          <stop offset='0%' stopColor='rgba(70, 20, 100, 0.45)' />
          <stop offset='60%' stopColor='rgba(20, 10, 28, 0.1)' />
          <stop offset='100%' stopColor='rgba(255, 122, 26, 0.4)' />
        </linearGradient>

        <pattern id={VARIANT_SVG_IDS.holoUnderlayGrid} width="2.5" height="2.5" patternUnits="userSpaceOnUse">
          <rect width="2.5" height="2.5" fill="none" stroke="#c9f2ff93" strokeWidth="1.5" opacity="0.6" />
        </pattern>

        <linearGradient id={VARIANT_SVG_IDS.holoUnderlayGradient} x1='0%' y1='0%' x2='100%' y2='100%'>
          <stop offset='0%' stopColor='rgba(213, 0, 232, 0)' />
          <stop offset='45%' stopColor='rgba(217, 46, 226, 0.14)' />
          <stop offset='60%' stopColor='rgba(30, 209, 143, 0.28)' />
          <stop offset='100%' stopColor='rgba(217, 11, 176, 0)' />
        </linearGradient>

        <linearGradient id={VARIANT_SVG_IDS.holoGradient} x1='0%' y1='0%' x2='100%' y2='0%'>
          <stop offset='0%' stopColor='rgba(16, 231, 227, 0.37)' />
          <stop offset='20%' stopColor='rgba(255, 34, 144, 0.48)' />
          <stop offset='50%' stopColor='rgba(72, 96, 205, 0.54)' />
          <stop offset='80%' stopColor='rgba(11, 255, 247, 0.32)' />
          <stop offset='100%' stopColor='rgba(255, 101, 101, 0)' />
        </linearGradient>

        <filter id={VARIANT_SVG_IDS.antiqueFilter}>

          <feColorMatrix
            type='matrix'
            values='0.60 0.40 0.20 0 0  
                    0.40 0.35 0.15 0 0  
                    0.25 0.20 0.10 0 0  
                    0 0 0 1 0'
            result='sepia'
          />

          <feTurbulence type='fractalNoise' baseFrequency='0.8' numOctaves='4' result='noise' />
          <feColorMatrix type='matrix' values='0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 0.4 0' result='subtleNoise' />
          <feBlend in='sepia' in2='subtleNoise' mode='multiply' result='texturedSepia' />

          <feTurbulence type='turbulence' baseFrequency='0.03' numOctaves='2' seed='5' result='stains' />
          <feColorMatrix type='matrix' values='0 0 0 0 0.3  0 0 0 0 0.2  0 0 0 0 0.1  0 0 0 0.6 0' result='darkStains' />
          <feOffset dx='5' dy='5' in='darkStains' result='offsetStains' />
          <feBlend in='texturedSepia' in2='offsetStains' mode='multiply' result='stainedSepia' />

          <feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='1' seed='10' result='spots' />
          <feColorMatrix type='matrix' values='0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 15 -13' result='denseSpots' />
          <feComposite in='stainedSepia' in2='denseSpots' operator='out' result='spottedSepia' />
          <feComposite in='stainedSepia' in2='denseSpots' operator='over' />

        </filter>

        <filter id={VARIANT_SVG_IDS.foilFilter}>
          <feColorMatrix
            type='matrix'
            values='1.1 0 0 0 0  0 1.1 0 0 0  0 0 1.1 0 0  0 0 0 1 0'
          />
        </filter>

        <linearGradient id={VARIANT_SVG_IDS.foilGradient} x1='0%' y1='0%' x2='100%' y2='100%'>
          <stop offset='0%' stopColor='rgba(0, 93, 232, 0)' />
          <stop offset='45%' stopColor='rgba(46, 61, 226, 0.34)' />
          <stop offset='60%' stopColor='rgba(71, 100, 184, 0.48)' />
          <stop offset='100%' stopColor='rgba(29, 71, 209, 0)' />
        </linearGradient>

        <filter id={VARIANT_SVG_IDS.ghostFilter}>
          <feColorMatrix
            type='matrix'
            values='-1 0 0 0 1  0 -1 0 0 1  0 0 -1 0 1  0 0 0 1 0'
          />
          <feColorMatrix
            type='matrix'
            values='0.33 0.33 0.33 0 0.08  0.33 0.33 0.33 0 0.1  0.33 0.33 0.33 0 0.14  0 0 0 0.85 0'
          />
        </filter>
        <radialGradient id={VARIANT_SVG_IDS.ghostGradient} cx='50%' cy='35%' r='65%'>
          <stop offset='0%' stopColor='rgba(225,248,255,0.3)' />
          <stop offset='100%' stopColor='rgba(180,212,240,0)' />
        </radialGradient>

        <filter id={VARIANT_SVG_IDS.blueprintFilter}>
          <feColorMatrix type="matrix" values="
    0.33 0.33 0.33 0 0
    0.33 0.33 0.33 0 0
    0.33 0.33 0.33 0 0
    0.00 0.00 0.00 1 0" />
          <feComponentTransfer>
            <feFuncR type="table" tableValues="0.1 0" />
            <feFuncG type="table" tableValues="0.4 0" />
            <feFuncB type="table" tableValues="0.8 0.2" />
          </feComponentTransfer>
        </filter>

        <filter id={VARIANT_SVG_IDS.blueprintFilterPaper}>
          <feTurbulence type="fractalNoise" baseFrequency="0.8" numOctaves="1" result="noise" />
          <feDiffuseLighting in="noise" lightingColor="#afc9ff" surfaceScale="1">
            <feDistantLight azimuth="45" elevation="35" />
          </feDiffuseLighting>
          <feComposite operator="in" in2="SourceGraphic" />
        </filter>

        <pattern id={VARIANT_SVG_IDS.blueprintGrid} width="10" height="10" patternUnits="userSpaceOnUse">
          <path d="M 10 0 L 0 0 0 10" fill="none" stroke="rgba(255,255,255,0.15)" strokeWidth="0.5" />
          <path d="M 5 0 L 5 10 M 0 5 L 10 5" fill="none" stroke="rgba(255,255,255,0.15)" strokeWidth="0.2" />
        </pattern>


        <filter id={VARIANT_SVG_IDS.crayonFilter}>
          <feColorMatrix type="matrix" values="
    1.2 0 0 0 0
    0   1.2 0 0 0
    0   0   1.2 0 0
    0   0   0   1 0" result="clumpy" />

          <feTurbulence type="fractalNoise" baseFrequency="0.10" numOctaves="1" stitchTiles="stitch" result="wobbleNoise" />
          <feDisplacementMap in="clumpy" in2="wobbleNoise" scale="10" xChannelSelector="R" yChannelSelector="G" result="wobbledImage" />

          <feTurbulence type="turbulence" baseFrequency="0.11" numOctaves="1" seed="42" result="crayonTexture" />

          <feBlend in="wobbledImage" in2="crayonTexture" mode="overlay" result="crayonArt" />

          <feComponentTransfer in="crayonArt">
            <feFuncR type="linear" slope="1.3" intercept="-0.1" />
            <feFuncG type="linear" slope="1.3" intercept="-0.1" />
            <feFuncB type="linear" slope="1.3" intercept="-0.1" />
          </feComponentTransfer>
        </filter>


        <filter id={VARIANT_SVG_IDS.crayonFilterFingerpaint} x="-10%" y="-10%" width="120%" height="120%">
          <feTurbulence type="fractalNoise" baseFrequency="0.6" numOctaves="1" result="edgeNoise" />
          <feDisplacementMap in="SourceGraphic" in2="edgeNoise" scale="5" xChannelSelector="R" yChannelSelector="G" />
        </filter>

        {/* --- Cosmic Nebula Variant Filter --- */}
        <filter id={VARIANT_SVG_IDS.cosmicFilter} x="-30%" y="-30%" width="160%" height="160%">
          {/* Step 1: Isolate blacks and reds, turning them into bright star-silver */}
          <feColorMatrix
            type="matrix"
            values="-1.0  -1.0  -1.0   0.0   0.95
            -1.0  -1.0  -1.0   0.0   0.95
            -1.0  -1.0  -1.0   0.0   1.00
             0.0   0.0   0.0   1.0   0.0"
            result="isolatedArt"
          />

          {/* Step 2: Create a soft, cosmic energy glow from the artwork lines */}
          <feGaussianBlur in="isolatedArt" stdDeviation="1.5" result="blurGlow" />

          {/* Step 3: Combine the sharp artwork lines over their own celestial glow */}
          <feComposite in="isolatedArt" in2="blurGlow" operator="over" />
        </filter>

        {/* Cosmic Nebula Gas Sweep */}
        <linearGradient id={VARIANT_SVG_IDS.cosmicGradient} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="rgba(11, 3, 26, 0)" />
          <stop offset="30%" stopColor="rgba(139, 92, 246, 0.15)" /> {/* Deep Void Violet */}
          <stop offset="50%" stopColor="rgba(236, 72, 153, 0.45)" /> {/* Nebula Pink */}
          <stop offset="55%" stopColor="rgba(6, 182, 212, 0.4)" />   {/* Supernova Cyan */}
          <stop offset="70%" stopColor="rgba(139, 92, 246, 0.1)" />
          <stop offset="100%" stopColor="rgba(11, 3, 26, 0)" />
        </linearGradient>


        {/* --- Cutesy Transparent Deep-Pink Filter --- */}
        <filter id={VARIANT_SVG_IDS.cutesyFilter} x="0%" y="0%" width="100%" height="100%">
          <feColorMatrix
            type="matrix"
            values="0.0   0.0   0.0   0.0   0.90
            0.0   0.0   0.0   0.0   0.20
            0.0   0.0   0.0   0.0   0.55
            0.0  -1.0  -1.0   1.0   0.0"
          />
        </filter>

        {/* Pastel Pink Harlequin Pattern */}
        <pattern id={VARIANT_SVG_IDS.cutesyPattern} width="12" height="12" patternUnits="userSpaceOnUse">
          {/* Light pink base */}
          <rect width="12" height="12" fill="#faedf2" />
          {/* Soft darker pink intersecting diamonds */}
          <path d="M 6 0 L 12 6 L 6 12 L 0 6 Z" fill="#fde0ec" opacity="0.6" />
        </pattern>

        <clipPath id={VARIANT_SVG_IDS.cutesyClipPath}>
          <rect x='0' y='0' width='66' height='96' rx='4.5' ry='4.5' />
        </clipPath>

        <g id={VARIANT_SVG_IDS.cutesyPetal}>
          <path d='M 0,0 C -2.6,-4.2 -4.2,-6.5 0,-9.8 C 4.2,-6.5 2.6,-4.2 0,0' fill='#f1afc3' />
        </g>

        <g id={VARIANT_SVG_IDS.cutesyBlossom}>
          <path d='M 0,0 C -2.5,-3.5 -3.5,-6.5 0,-8 C 3.5,-6.5 2.5,-3.5 0,0' fill='#ea90ab' />
          <path d='M 0,0 C -2.5,-3.5 -3.5,-6.5 0,-8 C 3.5,-6.5 2.5,-3.5 0,0' fill='#f6a6c0' transform='rotate(72)' />
          <path d='M 0,0 C -2.5,-3.5 -3.5,-6.5 0,-8 C 3.5,-6.5 2.5,-3.5 0,0' fill='#f09cb5' transform='rotate(144)' />
          <path d='M 0,0 C -2.5,-3.5 -3.5,-6.5 0,-8 C 3.5,-6.5 2.5,-3.5 0,0' fill='#f08dad' transform='rotate(216)' />
          <path d='M 0,0 C -2.5,-3.5 -3.5,-6.5 0,-8 C 3.5,-6.5 2.5,-3.5 0,0' fill='#f18dab' transform='rotate(288)' />
          <circle cx='0' cy='0' r='0.8' fill='#ffffff' />
        </g>

        {/* basic inversion filter (CSS filter: prop too slow) */}
        <filter id={VARIANT_SVG_IDS.matchaFilter} x="0%" y="0%" width="100%" height="100%">
          <feColorMatrix
            type="matrix"
            values="-1 0 0 0 1
                    0 -1 0 0 1
                    0 0 -1 0 1
                    0 0 0 1 0"
          />
        </filter>

        {/* same invert-then-recolor approach as matcha, but hue-rotated from green to azure/lapis */}
        <filter id={VARIANT_SVG_IDS.rurikaraFilter} x="0%" y="0%" width="100%" height="100%">
          <feColorMatrix
            type="matrix"
            values="-1 0 0 0 1
                    0 -1 0 0 1
                    0 0 -1 0 1
                    0 0 0 1 0"
            result="inverted"
          />
          <feColorMatrix in="inverted" type="hueRotate" values="60" />
        </filter>

      </defs>

    </svg>
  );
}

export default function CardVariantOverlay({ variant, imageSrc, seed, faceDown = false, alt = '', title = '', className = 'front', animated = true }) {

  const baseClasses = `card-variant-svg ${variant} ${className}`.trim();

  if (!variant || !imageSrc) return null;

  const svgImage = (filterId) => (
    <image
      className='card-variant-base-image'
      href={imageSrc}
      xlinkHref={imageSrc}
      x='0'
      y='0'
      width='66'
      height='96'
      preserveAspectRatio='none'
      filter={filterId ? `url(#${filterId})` : undefined}
    />
  );


  // Simple hash function to turn a string into a seeded random number generator
  const getSeedStats = (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    return hash;
  };

  // Seed from the card it belongs to where the caller knows it, so that the front and back of
  // one card randomise together, and two cards sharing an image (every face-down back is the
  // same back1.png) still get their own splodges and stains.
  const hash = getSeedStats(seed ?? imageSrc);
  const cutesyFlowerOffsetSeconds = (Math.abs(Math.sin(hash * 0.173 + 1.97)) * 12).toFixed(3);

  // A helper to get a predictable random number between min and max
  const rng = (min, max, offset = 0) => {
    const val = Math.abs(Math.sin(hash + offset));
    return Math.floor(val * (max - min + 1) + min);
  };

  const rngOuts = {
    // Colors (Hues)
    splodgeColor: `hsl(${rng(0, 360, 1)}, 80%, 50%)`,
    markColor: `hsl(${rng(0, 360, 2)}, 90%, 60%)`,
    rectColor: `hsl(${rng(0, 360, 3)}, 70%, 50%)`,
    // Positions
    splodgePos: { x: rng(5, 50, 4), y: rng(10, 80, 5) },
    splodgeSize: rng(3, 7, 6),
    rectPos: { x: rng(30, 55, 6), y: rng(60, 85, 7) },
    pathRotation: rng(0, 360, 8),
    // Noise Seed (For the SVG filter itself)
    filterSeed: rng(1, 1000, 9),
    coffeeStainSeed: rng(1, 1000, 10),
    coffeeStainSize: rng(26, 30, 11),
    coffeeStainRotation: rng(0, 360, 12),
    coffeeStainOpacity: rng(10, 20, 13) / 100,
    coffeeStainX: rng(-10, 60, 14),
    coffeeStainY: rng(-10, 60, 15),
  };


  if (variant === 'booster') {
    return (
      <svg className={baseClasses} viewBox='0 0 66 96' role='img' aria-label={alt} xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink'>
        {title ? <title>{title}</title> : null}
        {svgImage(VARIANT_SVG_IDS.boosterFilter)}
        <rect x='-66' y='0' width='50' height='96' fill={`url(#${VARIANT_SVG_IDS.boosterGradient})`}>
          {animated ? <animate attributeName='x' values='0;10;0' dur='3.1s' repeatCount='indefinite' /> : null}
        </rect>
      </svg>
    );
  }

  if (variant === 'holo') {
    return (
      <svg className={baseClasses} viewBox='0 0 66 96' role='img' aria-label={alt} xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink'>
        {title ? <title>{title}</title> : null}
        {/* hard back to cards */}
        <rect x='0' y='0' width='66' height='96' fill='#ffffff' />
        {svgImage(VARIANT_SVG_IDS.holoFilter)}
        <rect x='-10' y='0' width='76' height='96' fill={`url(#${VARIANT_SVG_IDS.holoUnderlayGrid})`}></rect>
        <rect x='-10' y='0' width='76' height='96' fill={`url(#${VARIANT_SVG_IDS.holoUnderlayGradient})`}>
          {animated ? <animate attributeName='x' values='-10;0;-10' dur='4.4s' repeatCount='indefinite' /> : null}
        </rect>
        <rect transform="rotate(45)" x='-10' y='-50' width='90' height='200' fill={`url(#${VARIANT_SVG_IDS.holoGradient})`}>
          {animated ? <animate attributeName='x' values='-10;-20;-10' dur='3.1s' repeatCount='indefinite' /> : null}
        </rect>

      </svg>
    );
  }

  if (variant === 'antique') {
    return (
      <svg className={baseClasses} viewBox='0 0 66 96' role='img' aria-label={alt} xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink'>
        {title ? <title>{title}</title> : null}
        {/* hard back to cards */}

        {/* <!-- Base Card (darker parchment) --> */}
        <rect x='0' y='0' width='66' height='96' fill='#d2b48c' />

        {/* <!-- Apply the intense antique filter --> */}
        {/* Black pips are heavier than red, so knock them back against the parchment. A card
            back has no pips, so it keeps full opacity whatever suit it belongs to. */}
        <g opacity={faceDown || title.toLowerCase().includes('hearts') || title.toLowerCase().includes('diamonds') ? 1 : 0.66}>
          {svgImage(VARIANT_SVG_IDS.antiqueFilter)}
        </g>

        {/* <!-- Criss-cross water lines/stains --> */}
        <path d='M-10 14 H76 M-10 30 H76 M-10 48 H76 M-10 64 H76 M-10 82 H76 M10 -10 V106 M30 -10 V106 M50 -10 V106' stroke='#140c04' strokeWidth='1.5' strokeDasharray="0.25 1" opacity='0.15' />

        {/* <-- Randomly placed coffee mug stain --> */}
        {/* This needs to be made slightly wibbly */}
        <circle filter={`url(#${VARIANT_SVG_IDS.crayonFilterFingerpaint})`} cx={rngOuts.coffeeStainX} cy={rngOuts.coffeeStainY} r={rngOuts.coffeeStainSize} fill='none' stroke='#4b2e0c' strokeWidth='5' opacity={rngOuts.coffeeStainOpacity} transform={`rotate(${rngOuts.coffeeStainRotation}, ${rngOuts.coffeeStainX}, ${rngOuts.coffeeStainY})`} />

      </svg>
    );
  }

  if (variant === 'foil') {
    return (
      <svg className={baseClasses} viewBox='0 0 66 96' role='img' aria-label={alt} xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink'>
        {title ? <title>{title}</title> : null}
        {/* hard back to cards */}
        <rect x='0' y='0' width='66' height='96' fill='#ffffff' />
        {svgImage(VARIANT_SVG_IDS.foilFilter)}
        <rect x='-10' y='0' width='76' height='96' fill={`url(#${VARIANT_SVG_IDS.foilGradient})`}>
          {animated ? <animate attributeName='x' values='-10;0;-10' dur='4.4s' repeatCount='indefinite' /> : null}
        </rect>
        <path d='M0 0 L66 96 M-10 0 L56 96 M10 0 L76 96 M0 96 L66 0 M-10 96 L56 0 M10 96 L76 0' stroke='rgba(255,255,255,0.13)' strokeWidth='0.8' />
      </svg>
    );
  }

  if (variant === 'ghost') {
    return (
      <svg className={baseClasses} viewBox='0 0 66 96' role='img' aria-label={alt} xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink'>
        {title ? <title>{title}</title> : null}
        {/* hard back to cards */}
        <rect x='0' y='0' width='66' height='96' fill='#ffffff' />
        {svgImage(VARIANT_SVG_IDS.ghostFilter)}
        <rect x='0' y='0' width='66' height='96' fill={`url(#${VARIANT_SVG_IDS.ghostGradient})`} />
      </svg>
    );
  }

  if (variant === 'blueprint') {
    return (
      <svg className={baseClasses} viewBox='0 0 66 96' role='img' aria-label={alt} xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink'>
        {title ? <title>{title}</title> : null}
        {/* hard back to cards */}
        <rect x='0' y='0' width='66' height='96' fill='#ffffff' />
        <rect x='0' y='0' width='66' height='96' fill={`url(#${VARIANT_SVG_IDS.blueprintFilterPaper})`} />
        {svgImage(VARIANT_SVG_IDS.blueprintFilter)}
        <rect width="66" height="96" fill={`url(#${VARIANT_SVG_IDS.blueprintGrid})`} />
        {/* Rough technical markings in the corners */}
        <g stroke="rgba(255,255,255,0.7)" strokeWidth="0.5" fontFamily="monospace" fontSize="3">
          <path d="M 2 10 L 2 2 L 10 2" fill="none" />
          <text x="4" y="6">DWG NO. 402-A</text>

          <rect x="40" y="80" width="22" height="12" fill="none" strokeDasharray="2,1" />
          <text x="42" y="85" fontSize="3.5">APPROVED</text>
          <text x="42" y="89" fontSize="2">VER: 2.0.4</text>
        </g>
      </svg>
    );
  }

  if (variant === 'crayon') {

    return (
      <svg className={baseClasses} viewBox='0 0 66 96' role='img' aria-label={alt} xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink'>
        {title ? <title>{title}</title> : null}
        {/* hard back to cards */}
        <rect x='0' y='0' width='66' height='96' fill='#ffffff' />
        {svgImage(VARIANT_SVG_IDS.crayonFilter)}
        <g opacity="0.6"
          filter={`url(#${VARIANT_SVG_IDS.crayonFilterFingerpaint})`}
          transform={`translate(${rngOuts.splodgePos.x}, ${rngOuts.splodgePos.y})`}>
          <circle cx="5" cy="15" r={rngOuts.splodgeSize} fill={rngOuts.splodgeColor} />
          <circle cx="9" cy="18" r={rngOuts.splodgeSize * 0.875} fill={rngOuts.splodgeColor} />
          <circle cx="7" cy="12" r={rngOuts.splodgeSize * 0.75} fill={rngOuts.splodgeColor} />
        </g>
        <g opacity="0.4" filter={`url(#${VARIANT_SVG_IDS.crayonFilterFingerpaint})`}
          transform={`translate(${rngOuts.rectPos.x}, ${rngOuts.rectPos.y})`}>
          <rect x="55" y="85" width="30" height="21" fill={rngOuts.rectColor} />
          <rect x="52" y="88" width="24" height="8" fill={rngOuts.rectColor} />
        </g>
        <path d="M 10 50 L 25 85 M 10 85 L 25 30"
          stroke={rngOuts.markColor} strokeWidth="4.8"
          strokeLinecap="round"
          opacity="0.7"
          transform={`rotate(${rngOuts.pathRotation}, 33, 48)`}
          filter={`url(#${VARIANT_SVG_IDS.crayonFilterFingerpaint})`} />
      </svg>
    );
  }

  if (variant === 'cosmic' || variant === 's500th') {
    return (
      <svg className={baseClasses} viewBox='0 0 66 96' role='img' aria-label={alt} xmlns='http://www.w3.org/2000/svg' xmlnsXlink='http://www.w3.org/1999/xlink'>
        {title ? <title>{title}</title> : null}

        {/* Deep deep space void backing */}
        <rect x='0' y='0' width='66' height='96' fill='#2501b9' />

        {/* Special features for s500th variant */}
        {variant === 's500th' ? (
          <>
            <g opacity="0.75">

              {svgImage(VARIANT_SVG_IDS.cosmicFilter)}

              {/* top left star to seal the deal */}
              <polygon
                points="8,3 9.8,6.5 13.8,7.1 10.9,10 11.6,14 8,12.1 4.4,14 5.1,10 2.2,7.1 6.2,6.5"
                fill="#ffffff"
                x="3"
                y="3"
              />

              <rect opacity="0.2" x='-10' y='0' width='76' height='96' fill={`url(#${VARIANT_SVG_IDS.holoUnderlayGrid})`}></rect>

              <g
                filter={`url(#${VARIANT_SVG_IDS.crayonFilterFingerpaint})`}
                transform={`translate(${rngOuts.splodgePos.x}, ${rngOuts.splodgePos.y})`}>
                <circle cx="5" cy="15" r={rngOuts.splodgeSize * 1.1} fill={rngOuts.splodgeColor} />
                <circle cx="9" cy="18" r={rngOuts.splodgeSize * 1.2} fill={rngOuts.splodgeColor} />
                <circle cx="7" cy="12" r={rngOuts.splodgeSize * 1.3} fill={rngOuts.splodgeColor} />
              </g>

              <g
                filter={`url(#${VARIANT_SVG_IDS.crayonFilterFingerpaint})`}
                transform={`translate(${-rngOuts.splodgePos.x}, ${-rngOuts.splodgePos.y})`}>
                <circle cx="5" cy="15" r={rngOuts.splodgeSize * 1.1} fill={rngOuts.splodgeColor} />
                <circle cx="9" cy="18" r={rngOuts.splodgeSize * 1.2} fill={rngOuts.splodgeColor} />
                <circle cx="7" cy="12" r={rngOuts.splodgeSize * 1.3} fill={rngOuts.splodgeColor} />
              </g>

              <g filter={`url(#${VARIANT_SVG_IDS.crayonFilterFingerpaint})`}
                transform={`translate(${rngOuts.rectPos.x}, ${rngOuts.rectPos.y})`}>
                <rect x="55" y="85" width="30" height="21" fill={rngOuts.rectColor} />
                <rect x="52" y="88" width="24" height="8" fill={rngOuts.rectColor} />
              </g>

              <path d="M 5 50 L 25 85 M 10 85 L 25 30"
                stroke={rngOuts.markColor} strokeWidth="5"
                strokeLinecap="round"
                transform={`rotate(${-rngOuts.pathRotation}, 33, 48)`}
                filter={`url(#${VARIANT_SVG_IDS.crayonFilterFingerpaint})`} />

            </g>

          </>
        ) : <g opacity="0.75">
          {/* Render the glowing star-silver card artwork */}
          {svgImage(VARIANT_SVG_IDS.cosmicFilter)}
        </g>}

        {/* Moving Nebula Gas Overlay */}
        <rect x='-96' y='-96' width='258' height='288' fill={`url(#${VARIANT_SVG_IDS.cosmicGradient})`} pointerEvents='none' style={{ mixBlendMode: 'screen' }}>
          {animated ? (
            <animateTransform
              attributeName="transform"
              type="translate"
              from="-80, -110"
              to="80, 110"
              dur="6s"
              repeatCount="indefinite"
            />
          ) : null}
        </rect>

        {/* --- Twinkling Smattering of Stars --- */}
        {/* Group 1: Slow, deep background twinkle */}
        <g fill='#ffffff'>
          <circle cx='5' cy='12' r='0.25' />
          <circle cx='52' cy='55' r='0.25' />
          <circle cx='40' cy='85' r='0.25' />
          <circle cx='8' cy='68' r='0.25' />
          <circle cx='48' cy='10' r='0.25' />
          {animated ? (
            <animate
              attributeName="opacity"
              values="0.3; 0.6; 0.3"
              dur="3.7s"
              repeatCount="indefinite"
            />
          ) : <animate attributeName="opacity" values="0.3" />}
        </g>

        {/* Group 2: Medium alternating mid-ground twinkle */}
        <g fill='#ffffff'>
          <circle cx='61' cy='15' r='0.25' />
          <circle cx='14' cy='45' r='0.25' />
          <circle cx='22' cy='78' r='0.25' />
          <circle cx='30' cy='28' r='0.25' />
          <circle cx='58' cy='38' r='0.25' />
          {animated ? (
            <animate
              attributeName="opacity"
              values="0.6; 0.1; 0.6"
              dur="4.3s"
              repeatCount="indefinite"
            />
          ) : <animate attributeName="opacity" values="0.6" />}
        </g>

        {/* Group 3: Quick, sharp mid-ground pulse */}
        <g fill='#ffffff'>
          <circle cx='12' cy='22' r='0.45' />
          <circle cx='42' cy='70' r='0.45' />
          <circle cx='34' cy='14' r='0.45' />
          <circle cx='9' cy='52' r='0.45' />
          {animated ? (
            <animate
              attributeName="opacity"
              values="0.2; 0.7; 0.2"
              dur="2.9s"
              repeatCount="indefinite"
            />
          ) : <animate attributeName="opacity" values="0.2" />}
        </g>

        {/* Group 4: Remaining mid-ground stars offsetting the pulse */}
        <g fill='#ffffff'>
          <circle cx='54' cy='31' r='0.45' />
          <circle cx='19' cy='58' r='0.45' />
          <circle cx='57' cy='76' r='0.45' />
          <circle cx='26' cy='88' r='0.45' />
          {animated ? (
            <animate
              attributeName="opacity"
              values="0.8; 0.2; 0.8"
              dur="3.4s"
              repeatCount="indefinite"
            />
          ) : <animate attributeName="opacity" values="0.8" />}
        </g>

        {/* Group 5: Crisp foreground bursts */}
        <g fill='#ffffff'>
          <circle cx='48' cy='20' r='0.65' />
          <circle cx='15' cy='72' r='0.65' />
          <circle cx='55' cy='62' r='0.55' />
          <circle cx='23' cy='16' r='0.55' />
          {animated ? (
            <animate
              attributeName="opacity"
              values="0.3; 0.98; 0.3"
              dur="5.1s"
              repeatCount="indefinite"
            />
          ) : <animate attributeName="opacity" values="0.3" />}
        </g>

      </svg>
    );
  }

  if (variant === 'halloween') {
    // Web corner, indexed by rng(0, 3): top-left, top-right, bottom-left, bottom-right
    const webTransforms = [
      undefined,
      'translate(66 0) scale(-1 1)',
      'translate(0 96) scale(1 -1)',
      'translate(66 96) scale(-1 -1)',
    ];
    return (
      <svg
        className={`${baseClasses} halloween-card-frame`}
        style={{ '--pk-halloween-jiggle-offset': animated ? `-${(rng(0, 49, 17) / 100).toFixed(2)}s` : '0s' }}
        viewBox='0 0 66 96'
        role='img'
        aria-label={alt}
      >
        {title ? <title>{title}</title> : null}

        <g>
          {svgImage(VARIANT_SVG_IDS.halloweenFilter)}
        </g>
        <rect x='0' y='0' width='66' height='96' fill={`url(#${VARIANT_SVG_IDS.halloweenGradient})`} />
        <rect
          className={animated ? 'pk-halloween-glow' : undefined}
          x='0' y='0' width='66' height='96'
          fill='#ff7a1a'
          opacity={animated ? undefined : 0.12}
        />
        <rect x='0.6' y='0.6' width='64.8' height='94.8' rx='4.2' ry='4.2' fill='none' stroke='rgba(255, 122, 26, 0.8)' strokeWidth='1.2' />

        <g
          fill='none'
          stroke='rgba(235, 235, 235, 0.7)'
          strokeWidth='2'
          strokeLinecap='round'
          transform={webTransforms[rng(0, 3, 16)]}
        >
          <path d='M0 0 L24 0 M0 0 L0 24 M0 0 L17 17' />
          <path d='M0 7 Q7 7 7 0 M0 14 Q12 13 14 0 M0 21 Q16 19 20 0' />
        </g>

      </svg>
    );
  }

  if (variant === 'cutesy' || variant === 'matcha' || variant === 'rurikara') {
    return (
      <svg
        className={`${baseClasses} cutesy-card-frame`}
        style={{ '--pk-cutesy-flower-offset': animated ? `-${cutesyFlowerOffsetSeconds}s` : '0s' }}
        viewBox='0 0 66 96'
        role='img'
        aria-label={alt}
      >
        {title ? <title>{title}</title> : null}

        <g filter={variant === 'matcha' ? `url(#${VARIANT_SVG_IDS.matchaFilter})` : variant === 'rurikara' ? `url(#${VARIANT_SVG_IDS.rurikaraFilter})` : undefined}>

          <g clipPath={`url(#${VARIANT_SVG_IDS.cutesyClipPath})`}>
            {/* Pink patterned background paper */}
            <rect x='0' y='0' width='66' height='96' fill={`url(#${VARIANT_SVG_IDS.cutesyPattern})`} />

            {/* Isolated stark white card artwork with transparency */}
            <g opacity="0.85">
              {svgImage(VARIANT_SVG_IDS.cutesyFilter)}
            </g>
          </g>

          <rect x='0.6' y='0.6' width='64.8' height='94.8' rx='4.2' ry='4.2' fill='none' stroke='rgba(255, 180, 205, 0.65)' strokeWidth='1.2' />

          <g>
            <g className={animated ? 'pk-cutesy-petal-left pk-cutesy-dp-1' : undefined}>
              <g transform='scale(1.2)'>
                <use href={`#${VARIANT_SVG_IDS.cutesyPetal}`} />
              </g>
            </g>
            <g className={animated ? 'pk-cutesy-petal-right pk-cutesy-dp-2' : undefined}>
              <g transform='scale(1.2)'>
                <use href={`#${VARIANT_SVG_IDS.cutesyPetal}`} />
              </g>
            </g>
            <g className={animated ? 'pk-cutesy-petal-middle pk-cutesy-dp-3' : undefined}>
              <g transform='scale(1.2)'>
                <use href={`#${VARIANT_SVG_IDS.cutesyPetal}`} />
              </g>
            </g>


            {(variant === 'matcha') && (
              <>
                <g transform='translate(7, 100) rotate(-18) scale(2)'>
                  <g>
                    <use href={`#${VARIANT_SVG_IDS.cutesyBlossom}`} />
                  </g>
                </g>

                <g transform='translate(70, 8) rotate(62) scale(2)'>
                  <g>
                    <use href={`#${VARIANT_SVG_IDS.cutesyBlossom}`} />
                  </g>
                </g>
              </>
            )}

            {variant === 'rurikara' && (
              <>
                <g transform='translate(-2, 8) rotate(-18) scale(2)'>
                  <g>
                    <use href={`#${VARIANT_SVG_IDS.cutesyBlossom}`} />
                  </g>
                </g>

                <g transform='translate(67, 95) rotate(62) scale(2.2)'>
                  <g>
                    <use href={`#${VARIANT_SVG_IDS.cutesyBlossom}`} />
                  </g>
                </g>
              </>
            )}

            {variant === 'cutesy' && (
              <>
                <g transform='translate(7, 91) rotate(-18) scale(1.42)'>
                  <g className={animated ? 'pk-cutesy-pop-linger pk-cutesy-order-1' : undefined}>
                    <use href={`#${VARIANT_SVG_IDS.cutesyBlossom}`} />
                  </g>
                </g>

                <g transform='translate(7, 91) rotate(-18) scale(1.42)'>
                  <g className={animated ? 'pk-cutesy-pop-linger pk-cutesy-order-1' : undefined}>
                    <use href={`#${VARIANT_SVG_IDS.cutesyBlossom}`} />
                  </g>
                </g>

                <g transform='translate(60, 8) rotate(62) scale(1.02)'>
                  <g className={animated ? 'pk-cutesy-pop pk-cutesy-order-2' : undefined}>
                    <use href={`#${VARIANT_SVG_IDS.cutesyBlossom}`} />
                  </g>
                </g>

                <g transform='translate(60, 90) rotate(-78) scale(1.2)'>
                  <g className={animated ? 'pk-cutesy-pop pk-cutesy-order-3' : undefined}>
                    <use href={`#${VARIANT_SVG_IDS.cutesyBlossom}`} />
                  </g>
                </g>

                <g transform='translate(6, 7) rotate(8) scale(1.38)'>
                  <g className={animated ? 'pk-cutesy-pop-linger pk-cutesy-order-4' : undefined}>
                    <use href={`#${VARIANT_SVG_IDS.cutesyBlossom}`} />
                  </g>
                </g>

                <g transform='translate(4, 48) rotate(-42) scale(1.2)'>
                  <g className={animated ? 'pk-cutesy-pop pk-cutesy-order-6' : undefined}>
                    <use href={`#${VARIANT_SVG_IDS.cutesyBlossom}`} />
                  </g>
                </g>

                <g transform='translate(62, 46) rotate(32) scale(1.5)'>
                  <g className={animated ? 'pk-cutesy-pop-linger pk-cutesy-order-7' : undefined}>
                    <use href={`#${VARIANT_SVG_IDS.cutesyBlossom}`} />
                  </g>
                </g>
              </>
            )}

          </g>

        </g>

      </svg>
    );
  }

  return null;
}